<template>
    <div class="FilterWrapper flex flex-col justify-center">
        <CButton
            v-if="!showAlways && variant !== 'oneline'"
            class="w-full"
            :class="{ 'rounded-b-none shadow-card-box': isExpanded }"
            icon="filter-list"
            icon-right
            variant="primary-outline"
            @click="toggle()"
        >
            {{ isExpanded ? 'Skryť' : 'Zobraziť' }} filter<span v-if="countActiveFilters">
                ({{ countActiveFilters }})
            </span>
        </CButton>

        <CCardBox
            :class="[
                showAlways
                    ? { 'hidden': isExpanded, 'w-full': !isExpanded }
                    : { 'relative z-1 rounded-t-none': isExpanded, 'hidden': !isExpanded }
            ]"
            :plain="togglePlain"
            :variant="variant === 'oneline' || variant === 'nopadding' ? 'nopadding' : undefined"
        >
            <div class="space-y-3" :class="{ 'flex flex-col lg:flex-row': variant === 'oneline' }">
                <slot />

                <div
                    v-if="$slots.footer || (variant !== 'oneline' && !hideActions)"
                    class="flex flex-col gap-4 md:flex-row md:items-center md:justify-end md:gap-8"
                >
                    <slot name="footer" />
                </div>
            </div>
        </CCardBox>
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

const props = defineProps({
    variant: {
        type: String,
        default: 'default'
    },
    plain: {
        type: Boolean,
        default: false
    },
    hideActions: {
        type: Boolean,
        default: false
    },
    showAlways: {
        type: Boolean,
        default: false
    },
    defaultOpened: {
        type: Boolean,
        default: false
    },
    countActiveFilters: {
        type: Number,
        default: 0
    }
})

const emit = defineEmits(['reset', 'filter-visibility-change'])

const isExpanded = ref(props.defaultOpened)

const togglePlain = computed(() => {
    return props.plain || props.variant === 'oneline'
})

// Initialize isExpanded based on variant
if (props.variant === 'oneline') {
    isExpanded.value = true
}

function toggle() {
    isExpanded.value = !isExpanded.value
    emit('filter-visibility-change', isExpanded.value)
}
</script>